import Vue from "vue";

export const FeedbackListPage = () =>
  import("@/views/feedback/List.vue");

// export const UsersFeedbackListPage = () =>
//   import("@/views/feedback/UsersFeedbackList.vue");

// export const UsersFeedbackPage = () =>
//   import("@/views/feedback/UsersFeedback.vue");

export const FeedbackDetailSharedPage = () =>
  import("@/views/feedback/details/Shared.vue");
  
export const FeedbackDetailDashboardPage = () =>
  import("@/views/feedback/details/Dashboard.vue");

export const FeedbackDetailCommentPage = () =>
  import("@/views/feedback/details/Comments.vue");

  export const FeedbackDetailUsersPage = () =>
  import("@/views/feedback/details/Users.vue");

export const FeedbackDetailEditPage = () =>
  import("@/views/feedback/details/Edit.vue");

export const FeedbackDashboardPage = () =>
  import("@/views/feedback/details/Dashboard.vue" );

export const FeedbacksConfigurationPage = () =>
  import("@/views/feedback/configurations/Layout.vue");

export const FeedbacksConfigurationTypesPage = () =>
  import("@/views/feedback/configurations/FeedbackType.vue");

export const FeedbackDetailQuestionGroupsPage = () =>
  import("@/views/feedback/details/FeedbackQuestionGroup.vue");

export const FeedbackDetailQuestionsPage = () =>
  import("@/views/feedback/details/FeedbackQuestions.vue");

Vue.component("CreateFeedbackSideMenuComponent", () =>
import("@/views/feedback/side-menus/CreateFeedback.vue"));

Vue.component("DetailFeedbackSideMenuComponent", () =>
import("@/views/feedback/side-menus/DetailFeedback.vue"));

// Vue.component("DetailUserFeedbackSideMenuComponent", () =>
// import("@/views/feedback/side-menus/DetailUserFeedback.vue"));

Vue.component("UserFeedbackSideMenuComponent", () =>
import("@/views/feedback/side-menus/DetailUser.vue"));

export function registerFeedbackModule(r: any): any {
  if (r.length > 0 && r[0].children) {
    r[0].children = r[0].children.concat(
      {
        path: "feedback/surveys",
        component: FeedbackListPage
      },
      // {
      //   path: "feedback/surveys",
      //   component: UsersFeedbackListPage
      // },
      // {
      //   path: "feedback/surveys/:id",
      //   component: UsersFeedbackPage
      // },
      {
        path: "/feedback/configuration",
        component: FeedbacksConfigurationPage,
        children: [
          {
            path: "",
            redirect: "types"
          },
          {
            path: "types",
            component: FeedbacksConfigurationTypesPage
          }
        ]
      },
      {
        path: "feedback/survey/:id",
        component: FeedbackDetailSharedPage,
        children: [
          {
            path: "",
            redirect: "dashboard"
          },
          {
            path: "dashboard",
            component: FeedbackDetailDashboardPage
          },
          {
            path: "edit",
            component: FeedbackDetailEditPage
          },
          {
            path: "comments",
            component: FeedbackDetailCommentPage
          },
          {
            path: "questions",
            component: FeedbackDetailQuestionsPage
          },
          {
            path: "questiongroups",
            component: FeedbackDetailQuestionGroupsPage
          },
          {
            path: "users",
            component: FeedbackDetailUsersPage
          },
        ]
      }
    );
  }
  return r;
}
